/**
 * @param value - The number to round
 * @param maxDecimalPlaces - Maximum number of decimal places (default: 2, clamped to 0-10)
 * @returns The rounded number
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "toFixed", {
    enumerable: true,
    get: function() {
        return toFixed;
    }
});
const toFixed = (value, maxDecimalPlaces = 2)=>{
    const decimalPlaces = Math.min(Math.max(maxDecimalPlaces, 0), 10);
    const multiplier = 10 ** decimalPlaces;
    const roundedValue = Math.round(value * multiplier) / multiplier;
    if (Number.isNaN(roundedValue)) {
        return 0;
    }
    return roundedValue;
};
